import styles from './HasAdjustmentsFilter.module.scss';
import { HasAdjustments } from 'enums/HasAdjustments';
import { DropDownButton } from 'components/Buttons/DropDownButton/DropDownButton';

const options = ['All', HasAdjustments.HasAdjustments, HasAdjustments.NoAdjustments];

type Props = {
    hasAdjustments: HasAdjustments | undefined,
    onStatusChange: (value: HasAdjustments) => void
};

const HasAdjustmentsFilter = ({ hasAdjustments, onStatusChange }: Props) => (
        <DropDownButton 
            iconPosition='left'
            className={styles.control}
            items={options}
            onItemClick={(e) => onStatusChange(e.item === 'All' ? undefined : e.item)}
            text={` ${ hasAdjustments ?? 'Adjustments: All' } `}
            size={'small'}
            fillMode={'solid'}
            rounded={'small'}
            tabIndex={0}
        />
);
export default HasAdjustmentsFilter;